import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import { FormattedHTMLMessage } from 'react-intl';
import Tooltip from '../Tooltip';

class LabelDescription extends Component {
	render() {
		const { description, label } = this.props;
		return (
			<div className="label-description">
				<FormattedHTMLMessage id={label} />
				{description && <Tooltip description={description} />}
			</div>
		);
	}
}
LabelDescription.propTypes = {
	label: PropTypes.string,
	description: PropTypes.string
};
export default LabelDescription;
